import styled from 'styled-components';

export const Fieldset = styled.fieldset`
  border: none;
  margin: 0;
  padding: 0;
  width: 100%;
`;
